import React, { useState } from "react";

function Navbar() {

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="navbar">

      {/* LOGO */}
      <div className="logo">
        <a href="#home">
          <img src="/images/logo.png" alt="logo" />
        </a>
      </div>

      {/* HAMBURGER ICON */}
      <div 
        className={`hamburger ${menuOpen ? "active" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* NAVIGATION LINKS */}
      <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
        <a href="#about">About</a>
        <a href="#skills">Skills</a>
        <a href="#platforms">Platforms</a>
        <a href="#education">Education</a>
        <a href="#contact">Contact</a>
      </nav>

    </header>
  );
}

export default Navbar;